// extracted by mini-css-extract-plugin
module.exports = {"walletButton":"AddToWallet_walletButton__dHB2u","walletImage":"AddToWallet_walletImage__2TZkj"};